import { memo } from 'react'
import { useTranslation } from 'react-i18next'
import { Skeleton } from '../../atoms'

// Stands in for a list page (title, primary button, table) while its code loads
export const PageSkeleton = memo(() => {
  const { t } = useTranslation('admin-mobifull')
  return (
    <div className="page-skeleton" aria-busy="true">
      <p className="sr-only" role="status">
        {t('common.loading')}
      </p>
      <Skeleton shape="heading" />
      <Skeleton shape="button" className="page-skeleton__button" />
      <Skeleton shape="table" />
    </div>
  )
})

PageSkeleton.displayName = 'PageSkeleton'
